export default __webpack_public_path__ + "static/media/bracers_of_tribulation.76a89fa1.jpg";